import { jsx as o } from "react/jsx-runtime";
import { useState as g, useEffect as p } from "react";
import x from "next/link.js";
import N from "react-markdown";
import { tv as P } from "tailwind-variants";
import v from "./extractTextFromChildren.js";
import h from "./SyntaxHighlighter.js";
import w, { canEmbed as E } from "./CodePen.js";
import y, { canEmbed as k } from "./YouTube.js";
const i = {
  a: ({ node: t, ...e }) => /* @__PURE__ */ o(x, { ...e, className: "hover:no-underline underline" }),
  code: ({ className: t, children: e, node: l, ...n }) => {
    var r;
    return /* @__PURE__ */ o(
      h,
      {
        language: (r = t == null ? void 0 : t.match(/language-(.+?)$/)) == null ? void 0 : r[1],
        ...n,
        children: e
      }
    );
  },
  em: ({ node: t, ...e }) => /* @__PURE__ */ o("em", { ...e }),
  li: ({ node: t, ...e }) => /* @__PURE__ */ o("li", { ...e }),
  ol: ({ node: t, ...e }) => /* @__PURE__ */ o("ol", { ...e, className: "list-decimal pl-[2em]" }),
  p: ({ node: t, ...e }) => /* @__PURE__ */ o("p", { ...e }),
  pre: ({ node: t, ...e }) => /* @__PURE__ */ o(
    "pre",
    {
      ...e,
      className: "block bg-neutral-200 border border-neutral-300 overflow-x-auto p-1 rounded text-sm *:bg-inherit"
    }
  ),
  strong: ({ node: t, ...e }) => /* @__PURE__ */ o("strong", { ...e }),
  table: ({ node: t, ...e }) => /* @__PURE__ */ o("div", { className: "overflow-x-auto max-w-full", children: /* @__PURE__ */ o("table", { ...e, className: "border-collapse w-full" }) }),
  thead: ({ node: t, ...e }) => /* @__PURE__ */ o("thead", { ...e, className: "border-b" }),
  td: ({ node: t, ...e }) => /* @__PURE__ */ o("td", { ...e, className: "align-top last:border-0 border-r p-2" }),
  tr: ({ node: t, ...e }) => /* @__PURE__ */ o(
    "tr",
    {
      ...e,
      className: "even:bg-gray-100 even:border-y border-neutral-200"
    }
  ),
  th: ({ node: t, ...e }) => /* @__PURE__ */ o("td", { ...e, className: "last:border-0 border-r font-bold p-2" }),
  ul: ({ node: t, ...e }) => /* @__PURE__ */ o("ul", { ...e, className: "list-disc pl-[2em]" })
}, M = {
  img: (t) => /^(\/|https:\/\/.+?\.+?)/.test(t.src) ? /* @__PURE__ */ o("img", { alt: "", ...t, className: "my-4" }) : `![${t.alt}](${t.src})`
}, O = {
  a: ({ children: t, href: e, node: l, ...n }) => {
    const r = v(t), a = r.replace("!embed ", "");
    if (!r.startsWith("!embed"))
      return i.a({ children: t, href: e, node: l, ...n });
    if (E(e)) return /* @__PURE__ */ o(w, { href: e, title: a });
    if (k(e)) return /* @__PURE__ */ o(y, { href: e, title: a });
  }
}, T = P({
  base: ["flex", "flex-col", "gap-3", "overflow-x-auto"]
}), D = ({
  children: t,
  className: e,
  componentMap: l = {},
  id: n,
  supportsEmbeds: r,
  supportsImages: a,
  withExtendedFeatures: s
}) => {
  const [d, c] = g([]), m = {
    ...i,
    ...r && O,
    ...a && M,
    ...l
  }, u = Object.keys(m), b = async () => {
    c([await import("./chunks/index-CncZTjc0.js").then((f) => f.default)]);
  };
  return p(() => {
    !s || d.length > 0 || b();
  }, [s, d]), /* @__PURE__ */ o("div", { className: T({ class: e }), id: n, children: /* @__PURE__ */ o(
    N,
    {
      components: m,
      allowElements: u,
      remarkPlugins: s ? d : void 0,
      children: t
    }
  ) });
};
export {
  D as default
};
